import { gx } from "@/components/gtax/base";
import { Link } from "react-router-dom";
import { STANDARD, TIERS, usd } from "./data";

const TierCard = ({ t, i }) => (
  <article className="gx-card gx-tier p-10 flex flex-col" data-testid={`gtax-tier-${t.id}`}>
    <div className="flex justify-between items-baseline border-b border-[color:var(--line)] pb-6">
      <h3 className="gx-caps text-3xl">{t.name}</h3>
      <span className="gx-eyebrow">Tier {["I", "II", "III"][i]}</span>
    </div>
    <div className="mt-8">
      <div className="text-xs uppercase tracking-widest text-[color:var(--mute)]">Minimum allocation</div>
      <div className="gx-serif text-4xl mt-2 tabular-nums" data-testid={`gtax-tier-${t.id}-min`}>{usd(t.min)}</div>
    </div>
    <div className="mt-8 grid grid-cols-2 gap-y-4 text-sm">
      <span className="text-[color:var(--mute)]">Annual licence</span><span className="text-right tabular-nums">{usd(t.licence)}</span>
      <span className="text-[color:var(--mute)]">Profit share (member / desk)</span><span className="text-right tabular-nums">{t.split}</span>
    </div>
    <ul className="mt-8 pt-8 border-t border-[color:var(--line)] space-y-3 text-sm text-[color:var(--ink)]/90 flex-1">
      {t.perks.map((p) => <li key={p} className="flex gap-3"><span className="text-[color:var(--gold)]">—</span>{p}</li>)}
    </ul>
    <Link to={gx(`/access?tier=${t.id}`)} className="gx-ghost mt-10 text-center" data-testid={`gtax-tier-${t.id}-cta`}>Request {t.name}</Link>
  </article>
);

export const GtaxTiers = () => (
  <section id="tiers" className="py-28 gx-line" data-testid="gtax-tiers">
    <div className="gx-wrap">
      <p className="gx-eyebrow">Membership</p>
      <h2 className="gx-serif text-4xl md:text-5xl mt-6 max-w-2xl">Three tiers. One mandate. The same risk disclosures for all.</h2>
      <div className="mt-16 grid md:grid-cols-3 gap-6">{TIERS.map((t, i) => <TierCard key={t.id} t={t} i={i} />)}</div>
      <p className="mt-8 text-sm text-[color:var(--mute)]" data-testid="gtax-standard-note">
        Standard membership from {usd(STANDARD.min)}, no licence, 60/40 profit share. Profit share applies only to realised
        trading profit. No return is guaranteed and losses are shared pro-rata. Past performance doesn't guarantee future results.
      </p>
    </div>
  </section>
);
